import { getConfigFor } from "../../../../utils/configService";
import { SPLIT_FEATURES } from "../../../../utils/constants/feature";
import { ALGOLIA_EVENT_TYPE } from "../../constants/EventHelper";
import { AnalyticsEvent } from "../../core/AnalyticsEvent";
import { ProductViewedEventSchema } from "../../schemas/product/ProductViewedEventSchema";
import { CommonEventParams, getCommonParams } from "../../utils/CommonParams";

export interface ProductViewedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string,
  PRODUCTS: any,
  INDEX: string | null,
  EVENT_TYPE: string,
  QUERY_ID: string | null,
}

export class ProductViewedEvent extends AnalyticsEvent {
  constructor(params: ProductViewedEventParams) {
    super(ProductViewedEventSchema, ['segment']);
    this.createEventObject(params);
  }
}

export function trackProductViewedEvent(params: ProductViewedEventParams) {
  const { isEnabled: leapCdpReleaseOne } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_ONE)
  if (leapCdpReleaseOne) {
    new ProductViewedEvent({
      ...getCommonParams(),
      ...params,
      EVENT_TYPE: ALGOLIA_EVENT_TYPE.VIEW,
    }).track();
  }
}
